import React from 'react'
import bg from "../images/IMG_0095.jpg";
import Content from '../components/Content'
import Button from '../components/Button'
import {events} from "../constant"
import Footer from '../components/Footer'
import Nav from '../components/Nav'
import honeymoon from "../images/honeymoon.JPG"
import reception from "../images/mar_reception.jpg"
import birthday from "../images/birthday.jpg"
import wedding from "../images/wedding.jpg"
import conference from "../images/banquet.jpg"
export const images=[honeymoon,reception,birthday,wedding]
const Events = () => {
  return (
    <div>
       
        <div className="h-3/4 bg bg-cover bg-center">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">EVENTS</p>
          </div>
          </div>
          </div>
        {events.map((e,i)=>{
         if (i%2===0){
            return(
 <div key={i} className=" bg-[#fff4f4] container mx-auto md:grid grid-rows-1 grid-cols-2 gap-4 grid-flow-row sm:flex flex-col">
<div className="text-black sm:p-10 place-self-center">
            <Content isColor="black" title={e.title}
            subtitle={e.subtitle}
            content={e.content}/>
            <Button href="/inquiry" isColour={true} label='INQUIRY NOW'/>
          </div>
          <div className="bg-cover place-self-center">
            <img src={images[i]} alt="bg"/>
          </div>
          </div>
            )}
            else{
            return(
 <div key={i} className="container bg-[#fff4f4] mx-auto md:grid grid-rows-1 grid-cols-2 gap-4 grid-flow-row flex flex-col-reverse">
<div className="bg-cover place-self-center">
            <img src={images[i]} alt="bg"/>
          </div>
          <div className="text-black sm:p-10 place-self-center">
            <Content isColor="black" title={e.title}
            subtitle={e.subtitle}
            content={e.content}/>
            <Button href="/inquiry" isColour={true} label='INQUIRY NOW'/>
          </div>
          
          </div>)
            }
        })
    }
        <div className="container bg-[#fff4f4] mx-auto md:grid grid-rows-1 grid-cols-2 grid-flow-row sm:flex sm:flex-col">
            <img className="bg-cover object-fill" src={conference} alt="bg"/>
 
           <div className="text-black p-10">
            <div className="container mx-auto flex flex-col ">
        <span className=" p-2 mt-7 font-bold text-black text-3xl">Meetings</span>
        <span className=" p-2 text-xl text-black">Conference Room</span>
        <span className=" p-2 text-black text-sm">
          <p>We've got your back, We know that a successful meeting doesn't happen by accident.
It takes planning. Coordination. And giving you the right support at just the right time.
So we've grown and innovated meeting services in ways that have changed the
industry … and the way you meet. Delivering the impact you want and the features you
need to bring people, purpose and results together.</p>
<strong className="text-lg py-9">Certified Meeting Professionals</strong>
<p>When it comes to great experiences, our team of trusted experts plan, anticipate and
deliver every component of your experience, no matter the size or the complexity.
</p><strong className="text-lg py-9">Sarvoday Events</strong>
<p>A meeting is more than tables and chairs. It's more about the people, understanding
their meeting purpose and delivering an experience that delights and inspired. So go
ahead, imagine the possibilities</p></span>
    </div>
<Button isColour={true} href="/inquiry"label='INQUIRY NOW'/>
          </div>
          
        </div>
        <Footer/>
    </div>
  )
}

export default Events